// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"804":"5a56ea10","1077":"a7218945","4934":"a7218945","5184":"a7218945"}[chunkId] + ".chunk.css";
};